import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectapp } from "stateMgmt/appSlice";
import Typography from "@mui/material/Typography";
// import logger from "services/LoggingService";

import "./PrimaryDataFigure.scss";


const PrimaryDataFigure = (props) => {
  const value = props.value;
  const description = props.description;

  const theme = useSelector(selectapp).theme;

  useEffect(() => {}, []);

  return (
    <div style={{ height: "100%" }}>
      <div
        id={`cu${props.index}`}
        className="outer__div"
        style={{ backgroundColor: theme.backgroundColor, color: theme.color }}
        tabIndex={1}
        role="note"
      >
        <strong>
          {value.toLocaleString()}
        </strong>
        <div
          style={{ backgroundColor: theme.backgroundColor, color: theme.color }}
        >
          <Typography
            sx={{ py: 0, px: 2 }}
            style={{ fontSize: "0.9rem", fontWeight: 700, whiteSpace: "pre-line" }}
          >
            {description}
          </Typography>
        </div>
      </div>
    </div>
  );
};

PrimaryDataFigure.propTypes = {
  index: PropTypes.number,
  value: PropTypes.string,
  description: PropTypes.string
};

export default PrimaryDataFigure;
